"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _excluded = ["onClick", "direction"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var CarouselArrows = function CarouselArrows(_ref) {
  var onClick = _ref.onClick,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'left' : _ref$direction,
    props = _objectWithoutProperties(_ref, _excluded);
  var buttonClass = (0, _classnames.default)("btn no-gutter remove-click-styling CarouselButton ".concat(direction), {
    hidden: (0, _lodash.includes)((0, _lodash.get)(props, 'className', ''), 'slick-disabled')
  });
  return /*#__PURE__*/_react.default.createElement("button", {
    className: buttonClass,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "icon-image-arrows"
  }));
};
var _default = exports.default = CarouselArrows;